// extracted by mini-css-extract-plugin
export default {"reactswitchcheckbox":"styles_reactswitchcheckbox__6JTjV","reactswitchlabel":"styles_reactswitchlabel__7h7Nq","reactswitchbutton":"styles_reactswitchbutton__dhU9X"};